import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Updates",
  "description": "",
  "published": "2007-01-08T00:00:00.000Z",
  "redirect_from": ["/blog/updates/swizec/329"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Wanted to add nifty new features to the website and update the basic script and I somehow managed to bork most of the configurations and thus removed all the sidebars and static pages in a single swipe. Also installing the new modules isn't going as smoothly as I had hoped due to a bug being discovered in the installation script of Chlorine Boards.`}</p>
    <p>{`Bottom line is I can't be arsed right now to keep cracking my head with this so I'll finish fixing the site tomorrow. Sory for the inconvenience this causes anyone.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      